module.exports = __webpack_public_path__ + "static/img/6.22c0d31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/6.png
// module id = Z3pN
// module chunks = 0